import { render, staticRenderFns } from "./SamlSettingPage.vue?vue&type=template&id=6ec92e29&scoped=true"
import script from "./SamlSettingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlSettingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SamlSettingPage.vue?vue&type=style&index=0&id=6ec92e29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec92e29",
  null
  
)

export default component.exports